/**
 * samMissionAdapter — `currentUser.sam_mission` → la mission de Sam de l'accueil.
 *
 * Le serveur la sert sur le compte de l'élève (`UserResource`, `SamContextResolver::missionFor`) :
 * ce que son tuteur lui a prescrit sur sa dernière séance, à faire avant la suivante, et la
 * première activité pas encore faite. Seulement espace élève allumé et Sam ouvert pour lui :
 * ailleurs la clé est absente, et il n'y a pas de mission.
 *
 * Une mission sans activité n'en est pas une (`total` nul) : `null`, la page ne montre rien.
 */
import { type UISamMission } from "../../../ui/types/studentHome"

export type ApiSamMission = {
    live_occurrence_id?: number | null
    total?: number | null
    completed?: number | null
    next_activity_id?: string | number | null
}

export type StudentSamMission = UISamMission & {
    /** L'activité que « Je lance la mission » ouvre avec Sam. `null` : la mission est accomplie. */
    nextActivityId: string | number | null
}

export function toStudentSamMission(raw: ApiSamMission | null | undefined): StudentSamMission | null {
    const total = raw?.total ?? 0
    if (raw == null || total <= 0) return null
    const done = Math.min(Math.max(raw.completed ?? 0, 0), total)
    return { done, total, nextActivityId: raw.next_activity_id ?? null }
}
